module.exports = __webpack_public_path__ + "img/pdf.936993ab.png";